/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextHFour(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm84,72a8.00039,8.00039,0,0,0-8,8v24H199.30664L219.542,102.66211a7.99987,7.99987,0,1,0-15.08789-5.32422l-23.99805,68A7.99995,7.99995,0,0,0,188,176h40v24a8,8,0,0,0,16,0V136A8.00039,8.00039,0,0,0,236,128Z" />
    </Svg>
  );
}

export default TextHFour;
